import React from 'react';

function IconDolarSvg() {
  return (
    <svg
      width="94"
      height="94"
      viewBox="0 0 94 94"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M47 3.91699V90.0837"
        stroke="#800020"
        strokeWidth="7.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M66.5833 19.583H37.2083C33.5727 19.583 30.0859 21.0273 27.5151 23.5981C24.9443 26.1689 23.5 29.6557 23.5 33.2913C23.5 36.927 24.9443 40.4138 27.5151 42.9846C30.0859 45.5554 33.5727 46.9997 37.2083 46.9997H56.7917C60.4273 46.9997 63.9141 48.4439 66.4849 51.0148C69.0557 53.5856 70.5 57.0723 70.5 60.708C70.5 64.3437 69.0557 67.8305 66.4849 70.4013C63.9141 72.9721 60.4273 74.4163 56.7917 74.4163H23.5"
        stroke="#800020"
        strokeWidth="7.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default IconDolarSvg;
